import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import api from '@home/api/webpart'

@Component({
  components: {
  },
})
export default class BetterKolmar_sx extends Vue {

  submitRequest: webpart.betterKolmar.Submit 
  = { format: "SX",
      respondent : "",
      reporterInfo : "",
      place : "",
      exDatetime : "",
      detail : "",
      request : "",
      writer : false,
      witness : false }


  emptyCheck(val:webpart.betterKolmar.Submit){
    if(val.respondent == '' || val.reporterInfo == '' || val.place == '' || val.exDatetime =='' || val.detail =='' || val.request =='')
      return false
    return true
  }

  async onSubmit(){
    if(!this.emptyCheck(this.submitRequest)){
      await (window as any).alertAsync(this.$t("입력된_값을_확인해주세요"))
      return
    }
    api.reportDocument(this.submitRequest).then(async res=>{
      if(res){
        await (window as any).alertAsync(this.$t("처리완료"))
        this.submitRequest={format: "SX",
                            respondent : "",
                            reporterInfo : "",
                            place : "",
                            exDatetime : "",
                            detail : "",
                            request : "",
                            writer : false,
                            witness : false}
      }
    })
  }
}